export default "__VITE_ASSET__BZ5uEWGI__"